module.exports = __webpack_public_path__ + "img/parlaylabs.17a0a8b0.svg";